import * as React from 'react';

import { __t } from 'utils/language';
import { HEIGHT, WIDTH } from '../constants/sizes';

interface Props {
  url: string
}

const VideoFromFile = ({ url }: Props): JSX.Element | null => {
  const [hide, setHide] = React.useState(false);
  React.useEffect(() => {
    setHide(true);

    setTimeout(() => {
      setHide(false);
    }, 100);
  }, [url]);

  if (hide) {
    return null;
  }

  return (
    <video
      height={HEIGHT}
      width={WIDTH}
      controls
    >
      <source src={url} />
      <track kind="captions" />
      {__t('realm_outfit_video.html5_video_support')}
    </video>
  );
};

export default VideoFromFile;
